<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <Website v-if="!creating" @create="showCreate" @edit="editItem($event)" />
      <CreateTitle v-else @cancel="cancelTitle" :itemToEdit="itemToEdit" />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import { mapActions, mapGetters } from 'vuex';
import Website from '../../components/Admin/Website/Website.vue';
import CreateTitle from '../../components/Admin/Website/CreateTitle.vue';

export default {
  components: {
    Sidebar,
    TopNavbar,
    Website,
    CreateTitle,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    creating: false,
    isToggled: false,
    itemToEdit: null,
  }),
  methods: {
    ...mapActions(['retrieveUserProfile']),

    showCreate() {
      this.creating = true;
    },

    editItem(item) {
      this.itemToEdit = item;
      this.creating = true;
    },

    cancelTitle() {
      this.creating = false;
      this.itemToEdit = null;
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.retrieveUserProfile();
  },
};
</script>
